/**
 * 尾程商务/海外跟单详情页专用 tab 组件扩展工具
 *
 * 覆盖 isBookingNew 返回 true，以展示"目的港服务"等功能
 *
 * 注意：不能使用 extends 包装，否则会破坏源组件内部的
 * this.$options.extends.methods.xxx 调用链，导致无限递归。
 * 改用浅拷贝选项方式，保持原 extends 链不变。
 *
 * 覆盖 computed 的方式：
 * 在 beforeCreate 阶段修改 $options.computed，此时 Vue 已完成
 * extends/mixins 的选项合并，但 initState（设置 computed watcher）
 * 尚未执行，可安全覆盖。
 */

/**
 * 创建尾程商务详情页专用的 tab 组件扩展
 * @param {Object} baseComponent 源 tab 组件（普通选项对象）
 * @param {Object} computedOverrides 需要覆盖的 computed 属性
 * @returns {Object} 扩展后的组件定义
 */
export function createDetailTabComponent(baseComponent, computedOverrides = {}) {
  // 浅拷贝选项对象，保持原 extends 链不变（不添加额外的 extends 层）
  const extended = { ...baseComponent }

  // 覆盖 computed：创建新对象，合并原 computed 和覆盖项
  extended.computed = {
    ...(baseComponent.computed || {}),
    ...computedOverrides
  }

  // 使用 beforeCreate 确保 computed 覆盖在 extends 链中也生效
  // Vue 2 在 beforeCreate 时 $options.computed 已完成 extends/mixins 合并，
  // 但 initState（设置 computed watcher）尚未执行
  const overrides = computedOverrides
  const originalBeforeCreate = baseComponent.beforeCreate
  extended.beforeCreate = function() {
    // 先执行原始 beforeCreate
    if (Array.isArray(originalBeforeCreate)) {
      originalBeforeCreate.forEach(fn => fn.call(this))
    } else if (typeof originalBeforeCreate === 'function') {
      originalBeforeCreate.call(this)
    }
    // 确保 $options.computed 存在并覆盖目标属性
    if (!this.$options.computed) {
      this.$options.computed = {}
    }
    Object.keys(overrides).forEach(key => {
      this.$options.computed[key] = overrides[key]
    })
  }

  return extended
}
